import React, { useEffect, useMemo, useState } from 'react';
import { useIntl, useSelector, useDispatch, getLocale, history, useLocation } from 'umi';
import { Modal, Button, Form, Input, Select, Bubble } from 'tea-component';
import { ModalPrposType } from './ModalWrap';
import { addMenu, updateMenu } from '@/pages/dashboard/services/leftMenu';
import FormPath from '@/pages/dashboard/components/LeftMenu/components/FormPath';
import { useNameHooks, useMenuHooks, useFolderHooks, useListUserLevel, usePath, useNull, useSubFolderHooks } from './hooks';
import { getPathFromDashboard, parseUrlInfo } from '@/pages/dashboard/utils/utils';
import { PAGE_TYPE_DASHBOARD_CUSTOM, PAGE_TYPE_OUT_PATH, PAGE_TYPE_OUT_URL, PAGE_TYPE_PATH } from '@/pages/dashboard/_config/constant';
import { useDashboardPath } from '@/pages/dashboard/_config/databoardPath';
import { getBasePath } from '@/utils/utils';

export default (props: ModalPrposType) => {
  const { modalInfo: { type, item }, close } = props;
  const [loading, setLoading] = useState<boolean>(false); // loading
  const isCustomEdit = type === 'edit' && props?.modalInfo?.item?.page_type === PAGE_TYPE_DASHBOARD_CUSTOM;
  const dashboardCustomId = props?.modalInfo?.item?.dashboard_custom_id || '';
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const locale = getLocale();
  const pathList = useDashboardPath();
  const location = useLocation();
  // 名字相关
  const {
    nameCN,
    setNameCN,
    nameEN,
    setNameEN,
    nameENErr,
    setNameENErr,
    namePathENErr,
    setNamePathENErr,
    nameCNErr,
    checkNameEN,
    checkNameCN
  } = useNameHooks(item, formatMessage, 'dashboard');

  const { userInfo, currentGame, menuList, folderList, subFolderList } = useSelector(state => {
    // @ts-ignore
    const { currentGame, menuList, folderList, subFolderList } = state.dashboard;
    // @ts-ignore
    const { userInfo } = state.home;
    return {
      userInfo,
      currentGame,
      menuList,
      folderList,
      subFolderList,
    };
  });

  // menu相关
  const {
    selectMenu,
    setSelectMenu,
    menuErr,
    formatMenuList,
    checkMenu
  } = useMenuHooks({ currentGame, item, menuList, locale, formatMessage });

  // folder相关
  const {
    selectFolder,
    setSelectFolder,
    folderErr,
    formatFolderList,
    checkFolder
  } = useFolderHooks({ item, folderList, selectMenu, locale, formatMessage });

  // subfolder相关
  const {
    selectSubFolder,
    setSelectSubFolder,
    subFolderErr,
    formatSubFolderList,
  } = useSubFolderHooks({ item, subFolderList, selectFolder, locale, formatMessage });

  // userLevel
  const {
    userLevelList,
    selectedLevel,
    setSelectedLevel,
    userLevelErr,
    checkUserLevel
  } = useListUserLevel({ currentGame, userInfo, formatMessage, item });

  const [pdfFileUploadStatus, setPdfFileUploadStatus] = useState<string>('idle');
  
  const [pdfFile, setPdfFile] = useState<File | null>(null);

  // path相关
  const {
    selectedPath,
    setSelectedPath,
    pathInfo,
    setPathStateInfo,
    getPathInfo,
    pathInfoErr,
    setPathInfoErr,
    checkPathType,
    tableauList,
    presetExtInfo,
    setPresetExtStateInfo,
    presetExtInfoErr,
    getPresetExtInfo,
    checkPresetExtInfo,
    lookerExtInfo,
    setLookerExtStateInfo,
    lookerExtInfoErr,
    getLookerExtInfo,
    checkLookerExtInfo
  } = usePath({ formatMessage, userInfo, currentGame, item, setNamePathENErr, pdfFileUploadStatus });
  
  const { isNull = false } = useNull(selectedLevel, nameEN, selectMenu, selectFolder, selectedPath, getPathInfo, type);
  const isPath = selectedPath === 'path';
  const nameEnErrVal = isPath ? namePathENErr : nameENErr;
  const isError = namePathENErr || nameCNErr || menuErr || folderErr || userLevelErr || pathInfoErr || (pdfFileUploadStatus === "uploading");

  const doAddMenu = () => {
    if (!checkNameEN() || !checkNameCN() || !checkMenu() || !checkFolder() || !checkUserLevel() || !checkPathType() || !checkPresetExtInfo() || !checkLookerExtInfo()||loading) {
      return;
    }

    setLoading(true);
    const { game_code: gameCode, role_type: roleType, studio_code: studioCode } = currentGame || {};
    addMenu({
      menu_type: 2,
      level: selectedLevel,
      // menu_id: selectMenu ? parseInt(selectMenu) : 0,
      u_parent_id: selectSubFolder ?selectSubFolder : selectFolder,
      page_type: selectedPath,
      name_en: nameEN,
      name_cn: nameCN || nameEN,
      game_code: gameCode,
      role_type: roleType,
      studio_code: studioCode,
      user_id: userInfo?.userid,
      ...getPathInfo(),
      ...getPresetExtInfo(),
      ...getLookerExtInfo()
    }).then((res: any) => {
      // 记录增加的报表
      const { req } = res;
      dispatch({
        type: 'dashboard/getLeftMenuList',
        payload: {
          currentGame,
        }
      })// @ts-ignore
        .then(() => {
          if (selectedPath === PAGE_TYPE_OUT_PATH) {
            window.open(`${getBasePath()}${req?.url}`);
            return;
          }
          if (selectedPath === PAGE_TYPE_OUT_URL) {
            window.open(`${req?.url}`);
            return;
          }
          const path = getPathFromDashboard(req);
          // 跳转新菜单
          history.push(`/dashboard/game/${currentGame.game_code}/${path}`);
        });
      close();
    }, (err) => {
      const { msg, code } = err;
      // 本期只有一种状态 code：30011：代表重复，但是不能区分是哪个业务的重复，所以写不了配置文件，暂时在代码逻辑中处理
      const codeToMsg = code === 30011 ? formatMessage({ id: 'menu_dashboard_re_enter' }) : msg;

      isPath ? setNamePathENErr(codeToMsg) : setNameENErr(codeToMsg);
    }).finally(() => {
      setLoading(false);
    });
  };

  // 更新dashboard
  const doUpdateMenu = () => {
    if (!checkNameEN() || !checkNameCN() || !checkUserLevel() || !checkUserLevel() || !checkPathType() || !checkPresetExtInfo() || !checkLookerExtInfo() || loading) {
      return;
    }
    setLoading(true);
    const { game_code: gameCode } = currentGame || {};
    updateMenu({
      name_en: nameEN,
      name_cn: nameCN,
      level: selectedLevel,
      game_code: gameCode,
      u_id: item.id,
      page_type: selectedPath,
      dashboard_custom_id: dashboardCustomId,
      ...getPathInfo(),
      ...getPresetExtInfo(),
      ...getLookerExtInfo()
    }).then((res: any) => {
      const { req } = res;
      dispatch({
        type: 'dashboard/getLeftMenuList',
        payload: {
          currentGame
        }
      })// @ts-ignore
        .then(() => {
          if (selectedPath === PAGE_TYPE_OUT_PATH) {
            window.open(`${getBasePath()}${req?.url}`);
            return;
          }
          if (selectedPath === PAGE_TYPE_OUT_URL) {
            window.open(`${req?.url}`);
            return;
          }
          const path = getPathFromDashboard(req);
          const { realPath } = parseUrlInfo(location.pathname);

          if (realPath !== path) {
            // 跳转新菜单
            history.push(`/dashboard/game/${currentGame.game_code}/${path}`);
          }
        });
      close();
    }, (err) => {
      const { msg, code } = err;
      // 本期只有一种状态 code：30011：代表重复，但是不能区分是哪个业务的重复，所以写不了配置文件，暂时在代码逻辑中处理
      const codeToMsg = code === 30011 ? formatMessage({ id: 'menu_dashboard_re_enter' }) : msg;
      setNameENErr(codeToMsg);
      isPath ? setNamePathENErr(codeToMsg) : setNameENErr(codeToMsg);
    }).finally(() => {
      setLoading(false);
    });
  };

  // 点击confirm 按钮
  const handleClickConfirm = async () => {
    if (type === 'add') {
      doAddMenu();
    } else if (type === 'edit') {
      doUpdateMenu();
    }
  };

  // 选择框架报表时禁止输入名称
  const nameDisabled = useMemo(() => {
    const editDisabled = type === 'edit' && selectedPath === PAGE_TYPE_PATH;
    const addDisabled = type === 'add' && selectedPath === PAGE_TYPE_PATH && pathInfo?.path;
    return editDisabled || addDisabled;
  }, [type, selectedPath, pathInfo]);

  // 选择了框架报表的路径，切换到框架报表时，名称初始化设置
  useEffect(() => {
    if (pathInfo?.path && selectedPath === PAGE_TYPE_PATH) {
      const page = pathList?.find((item: any) => item?.value === pathInfo?.path);
      setNameEN(page?.name_en || '');
      setNameCN(page?.name_cn || '');
    }
  }, [pathInfo?.path, selectedPath]);

  return (
    <>
      <Modal.Body className='dbd-menu-edit-modal'>
        <Form>
          <FormPath
            selectedPath={selectedPath}
            isCustomEdit={isCustomEdit}
            setNamePathENErr={setNamePathENErr}
            setSelectedPath={setSelectedPath}
            pathInfo={pathInfo}
            setPathStateInfo={setPathStateInfo}
            pathInfoErr={pathInfoErr}
            setPathInfoErr={setPathInfoErr}
            checkPathType={checkPathType}
            tableauList={tableauList}
            formatMessage={formatMessage}
            pdfFile={pdfFile}
            setPdfFile={setPdfFile}
            pdfFileUploadStatus={pdfFileUploadStatus}
            setPdfFileUploadStatus={setPdfFileUploadStatus}
            presetExtInfo={presetExtInfo}
            setPresetExtStateInfo={setPresetExtStateInfo}
            presetExtInfoErr={presetExtInfoErr}
            checkPresetExtInfo={checkPresetExtInfo}
            lookerExtInfo={lookerExtInfo}
            setLookerExtStateInfo={setLookerExtStateInfo}
            lookerExtInfoErr={lookerExtInfoErr}
            checkLookerExtInfo={checkLookerExtInfo}
            type={type}
          />
          <Form.Item
            required={true}
            showStatusIcon={false}
            label={formatMessage({ id: 'dashboard_title' }) + formatMessage({ id: 'name' })}
            status={nameEnErrVal ? 'error' : undefined}
            message={nameEnErrVal}>
            <Input disabled={nameDisabled} style={{ width: '100%' }} value={nameEN} onChange={(val) => { setNameEN(val) }} onBlur={checkNameEN} placeholder={formatMessage({ id: 'menu_enter_dashboard_name' })} />
          </Form.Item>
          <Form.Item
            showStatusIcon={false}
            label={formatMessage({ id: 'chinese' }) + formatMessage({ id: 'name' })}
            status={nameCNErr ? 'error' : undefined}
            message={nameCNErr}>
            <Input disabled={nameDisabled} style={{ width: '100%' }} value={nameCN} onChange={(val) => { setNameCN(val) }} onBlur={checkNameCN} placeholder={formatMessage({ id: 'menu_enter_dashboard_ch_name' })} />
          </Form.Item>
          {type === 'add' && <Form.Item
            required={true}
            showStatusIcon={false}
            label={formatMessage({ id: 'menu' })}
            status={menuErr ? 'error' : undefined}
            message={menuErr}>
            <Select
              size='full'
              matchButtonWidth={true}
              appearance="button"
              options={formatMenuList}
              value={selectMenu}
              onChange={value => setSelectMenu(value)}
              onBlur={checkMenu}
              placeholder={formatMessage({ id: 'common_select_placeholder' })}
              tips={
                formatMenuList.length == 0 ? formatMessage({ id: 'menu_select_no_data' }) : ''
              }
            />
          </Form.Item>}
          {type === 'add' && <Form.Item
            showStatusIcon={false}
            required={true}
            label={formatMessage({ id: 'folder' })}
            status={folderErr ? 'error' : undefined}
            message={folderErr}>
            <Select
              size='full'
              matchButtonWidth={true}
              appearance="button"
              options={formatFolderList}
              value={selectFolder}
              onChange={value => setSelectFolder(value)}
              onBlur={checkFolder}
              placeholder={formatMessage({ id: 'common_select_placeholder' })}
              tips={
                formatFolderList.length == 0 ? formatMessage({ id: 'menu_select_no_data' }) : ''
              }
            />
          </Form.Item>}
          {type === 'add' && <Form.Item
            showStatusIcon={false}
            required={false}
            label={formatMessage({ id: 'subfolder' })}
            status={subFolderErr ? 'error' : undefined}
            message={subFolderErr}>
            <Select
              size='full'
              matchButtonWidth={true}
              appearance="button"
              options={formatSubFolderList}
              value={selectSubFolder}
              onChange={value => setSelectSubFolder(value)}
              // onBlur={checkSubFolder}
              placeholder={formatMessage({ id: 'common_select_placeholder' })}
              tips={
                formatSubFolderList.length == 0 ? formatMessage({ id: 'menu_select_no_data' }) : ''
              }
            />
          </Form.Item>}
          <Form.Item
            className='dbd-dialog-level'
            showStatusIcon={false}
            required={true}
            label={formatMessage({ id: 'menu_level' })}
            status={userLevelErr ? 'error' : undefined}
            message={userLevelErr}>
            <Bubble
              dark={true}
              placement='right'
              trigger='click'
              content={userLevelList.length ? <div>{userLevelList.map(item => <p>·{item.text}({item.des})</p>)}</div> : ''}>
              <Select
                size='full'
                matchButtonWidth={true}
                appearance="button"
                options={userLevelList}
                value={selectedLevel}
                onChange={value => setSelectedLevel(value)}
                onBlur={checkUserLevel}
                placeholder={formatMessage({ id: 'common_select_placeholder' })}
                tips={
                  userLevelList.length == 0 ? formatMessage({ id: 'menu_select_no_data' }) : ''
                }
              />
            </Bubble>
          </Form.Item>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          loading={loading}
          type="primary"
          disabled={isNull || Boolean(isError)}
          onClick={() => handleClickConfirm()}
        >
          {formatMessage({ id: 'menu_confirm' })}
        </Button>
        <Button type="weak" onClick={close}>{formatMessage({ id: 'menu_cancel' })}</Button>
      </Modal.Footer>
    </>
  );
};
